"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CompetencyLevelChangeSourceSchema () {
        return CompetencyLevelChangeSourceSchema;
    },
    get CompetencyLevelHistorySchema () {
        return CompetencyLevelHistorySchema;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _base = require("../base");
const _useractionrecord = require("../shared/user-action-record");
const CompetencyLevelChangeSourceSchema = _zod.z.enum([
    "manual",
    "review"
]);
const CompetencyLevelHistorySchema = _base.BaseDocument.extend({
    competency_assignment_id: _zod.z.instanceof(_bson.ObjectId),
    competency_id: _zod.z.instanceof(_bson.ObjectId),
    user_id: _zod.z.instanceof(_bson.ObjectId),
    previous_level: _zod.z.number().int().min(1).max(5).nullable(),
    new_level: _zod.z.number().int().min(1).max(5).nullable(),
    effective_date: _zod.z.instanceof(Date),
    source: CompetencyLevelChangeSourceSchema,
    created: _useractionrecord.UserActionRecord
});
